import { toast } from 'react-toastify';

import { all, takeLatest, call, put } from 'redux-saga/effects';

import api from '~/services/api';

import {
  getReportsSuccess,
  getReportsFailure,
  getGeneratedReportsSuccess,
  getGeneratedReportsFailure,
  generateReportSuccess,
  generateReportFailure,
} from './actions';
import {
  IGenerateReportRequestAction,
  IGetGeneratedReportsRequestAction,
  IGetReportsRequestAction,
  IReportTypes,
} from './types';

export function* getReports({ payload }: IGetReportsRequestAction) {
  const { params } = payload;

  try {
    const response = yield call(api.get, '/reports', { params });
    const { reports, totalReports } = response.data;

    yield put(getReportsSuccess(reports, totalReports));
  } catch (err) {
    yield put(getReportsFailure());
    toast.error('Erro ao listar relatórios.');
  }
}

export function* generateReport({ payload }: IGenerateReportRequestAction) {
  const { params } = payload;

  try {
    yield call(api.post, '/reports/generate', params);
    yield put(generateReportSuccess());
    toast.success('O relatório está sendo gerado...');
  } catch (err) {
    yield put(generateReportFailure());
    toast.error('Erro ao gerar relatório.');
  }
}

export function* getGeneratedReports({
  payload,
}: IGetGeneratedReportsRequestAction) {
  const { id, params } = payload;

  try {
    const response = yield call(api.get, `/reports/generated/${id}`, {
      params,
    });
    const { generatedReports, totalGeneratedReports } = response.data;

    yield put(
      getGeneratedReportsSuccess(generatedReports, totalGeneratedReports),
    );
  } catch (err) {
    yield put(getGeneratedReportsFailure());
    toast.error('Erro ao carregar histórico do relatório.');
  }
}

export default all([
  takeLatest(IReportTypes.GET_REPORTS_REQUEST, getReports),
  takeLatest(IReportTypes.GENERATE_REPORT_REQUEST, generateReport),
  takeLatest(IReportTypes.GET_GENERATED_REPORTS_REQUEST, getGeneratedReports),
]);
